import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import Logs from './pages/Logs';

import MyTasks from './pages/MyTasks';
import Setup from './pages/Setup';
import Team from './pages/Team';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Clients from './pages/Clients';
import ClientDetails from './pages/ClientDetails';
import KPIs from './pages/KPIs';
import Datasheets from './pages/Datasheets';
import References from './pages/References';
import ReferenceDetails from './pages/ReferenceDetails';
import Tickets from './pages/Tickets';
import UserTickets from './pages/UserTickets';
import TicketDetails from './pages/TicketDetails';
import Contracts from './pages/Contracts';
import ContractDetails from './pages/ContractDetails';
import Punching from './pages/Punching';
import PunchingDetails from './pages/PunchingDetails';
import ITProjects from './pages/ITProjects';
import ITProjectDetails from './pages/ITProjectDetails';
import SupportDashboard from './pages/SupportDashboard';
import ClientStatistics from './pages/ClientStatistics';
import Inbox from './pages/Inbox';
import InboxDetails from './pages/InboxDetails';
import ITSuppliers from './pages/ITSuppliers/ITSuppliers';
import ITSupplierDetails from './pages/ITSuppliers/ITSupplierDetails';
import SoftwareLicenses from './pages/SoftwareLicenses/SoftwareLicenses';
import SoftwareLicenseDetails from './pages/SoftwareLicenses/SoftwareLicenseDetails';
import Leads from './pages/Leads/Leads';
import LeadDetails from './pages/Leads/LeadDetails';
import ConvertLead from './pages/Leads/ConvertLead';
import CreateLead from './pages/Leads/CreateLead';
import Quotes from './pages/Quotes/Quotes';
import QuoteDetails from './pages/Quotes/QuoteDetails';
import CreateQuote from './pages/Quotes/CreateQuote';
import StrategicPlan from './pages/StrategicPlan';
import QuoteDashboard from './pages/Quotes/QuoteDashboard';
import RNDReport from './pages/RNDReport';
import GeoReport from './pages/GeoReport';
import ACTSChatBot from './pages/ACTSChatBot/ACTSChatBot';
import ACTSChatBotDetails from './pages/ACTSChatBot/ACTSChatBotDetails';
import Layout from './components/Layout';


function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  const setAuth = (token) => {
    localStorage.setItem('token', token);
    setToken(token);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  useEffect(() => {
    // Add a response interceptor
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <Router future={{ v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/login" element={!token ? <Login setAuth={setAuth} /> : <Navigate to="/" />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {token ? (
          <Route element={<Layout logout={logout} />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/my-tasks" element={<MyTasks />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/logs" element={<Logs />} />
            
            <Route path="/team" element={<Team />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/client-statistics" element={<ClientStatistics />} />
            <Route path="/clients/:id" element={<ClientDetails />} />
            <Route path="/kpis" element={<KPIs />} />
            <Route path="/datasheets" element={<Datasheets />} />
            <Route path="/references" element={<References />} />
            <Route path="/references/:id" element={<ReferenceDetails />} />
            <Route path="/user-tickets" element={<UserTickets />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/tickets/:id" element={<TicketDetails />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/contracts/:id" element={<ContractDetails />} />
            <Route path="/punching" element={<Punching />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/inbox/:id" element={<InboxDetails />} />

            <Route path="/leads" element={<Leads />} />
            <Route path="/leads/new" element={<CreateLead />} />
            <Route path="/leads/:id" element={<LeadDetails />} />
            <Route path="/leads/:id/convert" element={<ConvertLead />} />

            <Route path="/quotes" element={<Quotes />} />
            <Route path="/quotes/new" element={<CreateQuote />} />
            <Route path="/quotes/strategic-plan" element={<StrategicPlan />} />
            <Route path="/quotes/dashboard" element={<QuoteDashboard />} />
            <Route path="/quotes/:id" element={<QuoteDetails />} />

            <Route path="/it-suppliers" element={<ITSuppliers />} />
            <Route path="/it-suppliers/:id" element={<ITSupplierDetails />} />
            <Route path="/software-licenses" element={<SoftwareLicenses />} />
            <Route path="/software-licenses/:id" element={<SoftwareLicenseDetails />} />

            <Route path="/punching/:id" element={<PunchingDetails />} />
            <Route path="/it-projects" element={<ITProjects />} />
            <Route path="/it-projects/:id" element={<ITProjectDetails />} />
            <Route path="/support-dashboard" element={<SupportDashboard />} />
            <Route path="/rnd-report" element={<RNDReport />} />
            <Route path="/geo-report" element={<GeoReport />} />
            <Route path="/chatbot" element={<ACTSChatBot />} />
            <Route path="/chatbot/:sessionId" element={<ACTSChatBotDetails />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
